import * as styles from "./styles";

interface ButtonProps extends styles.ButtonProps {
  children: React.ReactNode | string;
  type: "button" | "submit" | "reset" | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

export const Button = (props: ButtonProps) => (
  <styles.Button
    type={props.type}
    onClick={props.onClick}
    inverted={props.inverted ?? false}
    fullWidth={props.fullWidth ?? false}
    disabled={props.disabled}
  >
    {props.children}
  </styles.Button>
);

Button.defaultProps = {
  type: "button",
};
